<template>
  <div>
    <v-dialog v-model="deleteLeadDialog" max-width="500px" persistent>
      <v-card class="pa-4">
        <v-card-title class="px-4">
          <h2 class="title">Delete Lead</h2>
        </v-card-title>

        <div class="py-4 px-5">
          <v-alert dense outlined type="error" icon="error" class="mb-2">
            <div class="body-2" style="color: rgba(0, 0, 0, 0.87)">
              {{ `Do you really want to delete lead for ${deleteLeadPreparedData.first_name} ${deleteLeadPreparedData.last_name}?` }}
            </div>
          </v-alert>
          <v-alert
            class="pa-2 mt-4"
            :value="!serverValidation"
            outlined
            color="error"
            icon="priority_high"
            transition="scale-transition"
          >
            <span class="caption">{{ serverValidationMessage }}</span>
          </v-alert>
        </div>
        <v-card-actions class="px-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeDeleteLead"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :loading="deleteLeadLoading"
            :disabled="deleteLeadLoading"
            @click="deleteLead"
            >Delete anyway</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ApiService from "@/common/api.service"
import { mapActions } from 'vuex'

export default {
  name: "DeleteLeads",
  data() {
    return {
      no_data: [null, "", undefined, "null"],
      deleteLeadDialog: false,
      deleteLeadLoading: false,
      deleteLeadPreparedData: {},
      serverValidation: true,
      serverValidationMessage: "Oops something went wrong...",
      server_errors: {},
      unsubscribe: null
    };
  },
  mounted () {
    this.unsubscribe = this.$store.subscribeAction(action => {
      if (action.type === 'vEmit' && action.payload.name === 'DeleteLead') {
          this.deleteLeadModal(action.payload.data)
      }
    })
  },
  beforeDestroy () {
    this.unsubscribe()
  },
  methods: {
    ...mapActions(['vEmit']),
    deleteLeadModal (item) {
      this.resetServerValidation()
      this.deleteLeadPreparedData = item
      this.deleteLeadDialog = true
      this.deleteLeadLoading = false
    },
    deleteLead () {
      this.resetServerValidation()
      this.deleteLeadLoading = true
      let body = {
        client_registration_id: this.deleteLeadPreparedData.client_registration_service_id
      }
      ApiService.put("/delete_lead", body)
        .then(response => {
          this.deleteLeadLoading = false
          this.vEmit({ 
            name: "notification", 
            data: {
              status: "success",
              text: "Lead has been successfully deleted."
            }
          });
          this.$emit('done')
          this.closeDeleteLead()
        })
        .catch(({ response }) => {
          this.deleteLeadLoading = false;
          this.serverValidation = false;
          if (response.data.error) {
            this.serverValidationMessage = this.titleCase(
              response.data.error
            );
          }
          if (response.data.message) {
            this.serverValidationMessage = response.data.message;
          }
          if (response.data.errors) {
            this.server_errors = response.data.errors;
          }
        });
    },
    closeDeleteLead () {
      this.deleteLeadDialog = false
    },
    titleCase(str) {
      return _.startCase(str.replace(/_/g, " "));
    },
    resetServerValidation() {
      this.serverValidation = true;
      this.serverValidationMessage = "Oops something went wrong...";
      this.server_errors = {};
    }
  }
};
</script>
